export default __webpack_public_path__ + "static/media/7.6ba30c6b.jpg";